import Heading from "@atoms/Heading/Heading";
import { HeadingLevel } from "@atoms/Heading/utils/types";
import { ArticleNonParagraphProps } from "@pages/Article/components/ArticleParagraphElements/utils/types";
import { cn } from "@util/helpers";
import parse, { DOMNode, domToReact, Element } from "html-react-parser";

/**
 * Renders a subheading element in an article.
 * This component processes the body string to extract heading elements
 * and applies appropriate styles and classes.
 */
const Subheading = ({
  bodyString,
  className,
  paragraphWidth,
}: ArticleNonParagraphProps): React.ReactElement => {
  return (
    <>
      {parse(bodyString, {
        replace: (node: DOMNode) => {
          const nodeE = node as Element;
          const children = nodeE.children as DOMNode[];
          const tagName = nodeE.name;

          if (!tagName || !tagName.startsWith("h")) {
            return domToReact([node]);
          }

          const level = parseInt(tagName.slice(1)) as HeadingLevel;

          if (isNaN(level) || level < 1 || level > 6) {
            return domToReact([node]);
          }

          return (
            <Heading level={level} className={cn(className, paragraphWidth)}>
              {domToReact(children)}
            </Heading>
          );
        },
      })}
    </>
  );
};

export default Subheading;
